import { ComplianceDocumentType } from "src/utils/documentSeriesEnum";
import { defineForm } from "../../../../core";
import { vendorPreserve } from "../../../_shared/preserve";
import { siiRegularInvoiceSchema } from "./schema";

export const siiRegularInvoiceConfig = defineForm({
  id: "sii_regular_invoice",
  createEndpoint: "/createSIIRegularInvoice",
  permission: "ManualDocumentsIN_Write",
  seriesPermission: "ManualDocumentsSeries_Read",
  documentClass: "Invoice",
  accountClass: "AccountReceivable",
  taxRatesChannel: "SII",
  invoiceType: "regularInvoice",
  complianceType: ComplianceDocumentType.RegularInvoice,
  requiresLegalRep: true,
  titleKey: "regular_invoice",
  complianceStandardKey: "sii",
  schema: siiRegularInvoiceSchema,
  preserveOnReset: vendorPreserve,
  sections: {
    customer: {
      hiddenFields: ["customerCompanyAddress"],
    },
  },
  omitFromPayload: ["customerCompanyAddress"],
});
